import styled from '@emotion/styled/macro';

const CardContent = styled('div')`
  --card-content-padding: 1rem;
  padding: var(--card-content-padding);

  @media (max-width: 420px) {
    --card-content-padding: 0.75rem;
  }

  @media (max-width: 320px) {
    --card-content-padding: 0.5rem;
  }
`;

export default CardContent;
